/**
 * Formats a numeric value as a currency string according to Belarusian locale.
 *
 * @param {number|string} value - The numeric value to format as currency.
 * @param {string} [currency="BYN"] - The ISO 4217 currency code to use for formatting.
 * @returns {string} A formatted currency string with the specified currency code.
 *                   Returns "0 BYN" if the input value is null, undefined, or not a number.
 */
function formatAsCurrency(value, currency = "BYN") {
  if (value === null || value === undefined || isNaN(value)) {
    return "0 BYN";
  }
  const formatter = new Intl.NumberFormat("ru-BY", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    currencyDisplay: "code",
  });

  return formatter.format(value).replace(/\s+/g, " ");
}
